import { faSearch } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import { Arrange, IconButton } from "@aviary";
import { l } from "@emerson/locales/i18n";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import { EmersonMiniCart } from "../../EmersonMiniCart/EmersonMiniCart";

import * as styles from "./MobileNavRightIcons.styles";

type Props = {
  toggleSearchModal: () => void;
};

const MobileNavRightIcons = ({ toggleSearchModal }: Props) => {
  const { t } = useTranslation();
  const { isUnauthenticated } = useSharedGlobalConfig();

  return (
    <Arrange alignment="center">
      <IconButton
        css={styles.searchButton}
        onClick={toggleSearchModal}
        isColor="system"
        aria-label={t(l.header.OpenSearch)}
      >
        <FontAwesomeIcon icon={faSearch} />
      </IconButton>
      {!isUnauthenticated && <EmersonMiniCart />}
    </Arrange>
  );
};

export { MobileNavRightIcons };
